import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIsDesktop } from "../hooks/useIsDesktop.jsx";
import PopOverButton from "./buttons/PopOverButton";
import { STATUSES } from "../enums/AppointmentStatus.jsx";

export default function Status({ status, dotPadding, testId }) {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const createDot = (id, rawStatus) => (
    //Id is used in CSS to add color style
    <div
      className="dot"
      id={id}
      style={{ margin: dotPadding }}
      {...(testId && { "data-testid": testId, "data-status": rawStatus })}
    />
  );

  const getStatusComponent = (title, dotId) =>
    isDesktop ? (
      <Tooltip title={t(title)}>{createDot(dotId, title)}</Tooltip>
    ) : (
      <PopOverButton content={t(title)} title={createDot(dotId, title)} />
    );

  switch (status) {
    case 1:
      return getStatusComponent(STATUSES.WAITING_CLINIC, "yellow");
    case 2:
      return getStatusComponent(STATUSES.ACTIVE, "green");
    case 3:
      return getStatusComponent("PastAppointment", "");
    case 4:
      return getStatusComponent(STATUSES.FINISHED, "blue");
    case 5:
      return getStatusComponent(STATUSES.INACTIVE, "red");
    case 6:
      return getStatusComponent(STATUSES.RESOLVED, "light-blue");
    case 7:
      return getStatusComponent(STATUSES.WAITING_USER, "yellow");
    default:
      return getStatusComponent("PastAppointment", "");
  }
}
